import { Props_SnippetHeading } from './Heading.props'
import React from 'react'

export const SnippetHeading = (props: Props_SnippetHeading) => {

    const {headingProps} = props

    return (
    <section className='snippet-heading'>
        <div className="snippet-heading__container">
            {(headingProps.level?.value && headingProps.heading?.value) && React.createElement(headingProps.level.value, { className: "snippet-heading__heading" }, headingProps.heading?.value) }
        </div>
    </section>
    )
}
